/* ============================================================
   עלמא — Click-anywhere-on-card → Open Quick View modal
   ------------------------------------------------------------
   On almaflowers.co.il, clicking anywhere on a product card opens
   a quick-view popup (variant + add-ons + add to cart) instead of
   navigating to the product detail page. Minimog only triggers
   the popup from the explicit "Quick add" button, so this script
   delegates clicks on product card links to that button.

   Key behaviours:
   - If a card has a quickview trigger (variants exist) → click
     anywhere on the card opens the popup.
   - If a card has no variants (single SKU) → the "+" button adds
     to cart; clicking the image still navigates to the product
     page (default Shopify behaviour).
   - Buttons inside the card (wishlist, compare, the + itself)
     keep their own click behaviour — we don't intercept them.
   ============================================================ */
(function () {
  'use strict';

  function isInteractive(el) {
    return !!el.closest(
      'button, .m-button, [data-product-url], ' +
      '.m-product-card__atc-button, .m-tooltip, ' +
      '[data-action], .m-wishlist-button, .m-compare-button, ' +
      'input, select, textarea'
    );
  }

  function findQuickviewTrigger(card) {
    // Minimog's quickview trigger button — present when product has variants
    return (
      card.querySelector('.m-product-quickview-button') ||
      card.querySelector('[data-product-url]')
    );
  }

  document.addEventListener(
    'click',
    function (e) {
      // Only handle clicks on links inside a product card
      var link = e.target.closest('.m-product-card a[href*="/products/"]');
      if (!link) return;

      var card = link.closest('.m-product-card');
      if (!card) return;

      // Don't hijack if user clicked an interactive control inside the card
      if (isInteractive(e.target)) return;

      var qvBtn = findQuickviewTrigger(card);
      if (!qvBtn) return; // no quickview available — let the link navigate

      // Open the quickview instead of navigating
      e.preventDefault();
      e.stopPropagation();
      qvBtn.click();
    },
    true /* capture phase — beats the default link */
  );
})();
